import graphqlClient from "../../../apollo";

class StockProvider {

    findStockByBranch(branchId) {
        return graphqlClient.query({
            query: require('./gql/Stock/findStockByBranch.graphql'),
            fetchPolicy: "network-only",
            variables: {branchId}
        })
    }


    findStock(id) {
        return graphqlClient.query({
            query: require('./gql/Stock/findStock.graphql'),
            fetchPolicy: "network-only",
            variables: {id:id}
        })
    }

    fetchStock() {
        return graphqlClient.query({
            query: require('./gql/Stock/fetchStock.graphql'),
            fetchPolicy: "network-only"
        })
    }

    paginateStock(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Stock/paginateStock.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }



    createStock(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Stock/createStock.graphql'),
            variables: {input}
        })
    }

    updateStock(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Stock/updateStock.graphql'),
            variables: {id, input}
        })
    }

     deleteStock(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Stock/deleteStock.graphql'),
            variables: {id}
        })
    }

}

export default new StockProvider()


